<template>
  <b-row class="contact-form" no-gutters align-v="center">
    <template v-if="!submitSuccess">
      <!-- <b-col xs="12" md="7" >
        <b-form-group
          label-cols-md="4"
          label-size="md"
          :label="$t('contact.name')"
        >
          <b-form-input
            :placeholder="$t('contact.name')"
            v-model="$v.form.from_name.$model"
            :state="validateState('from_name')"
            aria-describedby="input-from-name-feedback"
          ></b-form-input>
          <b-form-invalid-feedback
            id="input-from-name-feedback"
          >{{ $t('contact.validateMsg.required') }}.</b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col xs="12" md="7">
        <b-form-group
          label-cols-md="4"
          label-size="md"
          :label="$t('contact.email')"
        >
          <b-form-input
            :placeholder="$t('contact.email')"
            v-model="$v.form.from_email.$model"
            :state="validateState('from_email')"
            aria-describedby="input-from-email-feedback"
          ></b-form-input>
          <b-form-invalid-feedback
            id="input-from-email-feedback"
          >{{ form.from_email ? $t('contact.validateMsg.email') : $t('contact.validateMsg.required') }}</b-form-invalid-feedback>
        </b-form-group>
      </b-col> -->
      <b-col xs="12" md="7">
        <b-form-group
          label-cols-md="4"
          label-size="md"
          :label="$t('contact.phone')"
        >
          <b-form-input
            :placeholder="$t('contact.phone')"
            v-model="$v.form.from_telephone.$model"
            :state="validateState('from_telephone')"
            aria-describedby="input-from-phone-feedback"
          ></b-form-input>
          <b-form-invalid-feedback
            id="input-from-phone-feedback"
          >{{ form.from_telephone ? $t('contact.validateMsg.phone') : $t('contact.validateMsg.required') }}</b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col xs="12" md="7">
        <b-form-group
          label-cols-md="4"
          label-size="md"
          :label="$t('contact.description')"
        >
          <b-form-textarea
            :placeholder="$t('contact.description')"
            v-model="$v.form.from_message.$model"
            :state="validateState('from_message')"
            aria-describedby="input-from-description-feedback"
          ></b-form-textarea>
          <b-form-invalid-feedback
            id="input-from-description-feedback"
          >{{ $t('contact.validateMsg.required') }}</b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="7" class="button-div">
        <b-button
          type="submit"
          class="btn-submit-search"
          :id="buttonId"
          @click="createContact"
        >{{ $t('contact.send') }}</b-button>
      </b-col>
    </template>
    <template v-else>
      <b-col cols="7" class="text-center" :id="successMessageId">
        <p class="mb-2">{{ $t("contact.msgCreateSuccess.title") }}</p>
        <p>{{ $t("contact.msgCreateSuccess.content") }}</p>
      </b-col>
    </template>
  </b-row>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import {
  required,
  numeric,
  integer,
  minLength,
  maxLength,
  email
} from "vuelidate/lib/validators";
export default {
  name: "ContactForm",
  mixins: [validationMixin],
  props: {
    buttonId: {
      required: false
    },
    successMessageId: { required: false }
  },
  data() {
    return {
      form: {
        from_telephone: "",
        from_message: ""
      },
      submitSuccess: false
    };
  },
  validations: {
    form: {
      from_telephone: {
        numeric,
        integer,
        minLength: minLength(10),
        maxLength: maxLength(10)
      },
      from_message: {
        required
      }
    }
  },
  computed:{
    ...mapGetters('UserController', [ 'isMobile']),
  },
  methods: {
    ...mapActions("FaqController", ["USER_POST_CONTACT_IN_FAQ"]),
    ...mapActions('UserController', [ 'isTablet']),
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    createContact() {
      if (!this.$root.isAuthenticated) {
        this.openThairathLogin();
      }
      this.$v.form.$touch();
      if (this.$v.form.$anyError) return;
      let message = `${this.form.from_message} \n ${this.form.from_telephone}`
      this.USER_POST_CONTACT_IN_FAQ({from_message:message}).then(result => {
        this.submitSuccess = true;
        this.form = {
          from_name: "",
          from_email: "",
          from_telephone: "",
          from_message: ""
        };
        this.$nextTick(() => {
          this.$v.form.$reset();
        });
        $(document).ready(function() {
          $('#'+this.successMessageId).trigger("click");
        });
      });
    },
    openThairathLogin() {
			this.$root.signIn('faq/#contact-us');
		},
  }
};
</script>
<style lang="scss">
@import "style.scss";
</style>